var User = function (Properties = null) {
  Properties.UserId ? this.UserId = Properties.UserId : this.UserId = this.__proto__.UserId;
  Properties.FormOfAdress ? this.FormOfAdress = Properties.FormOfAdress : this.FormOfAdress = this.__proto__.FormOfAdress;
  Properties.FirstName ? this.FirstName = Properties.FirstName : this.FirstName = this.__proto__.FirstName;
  Properties.LastName ? this.LastName = Properties.LastName : this.LastName = this.__proto__.LastName;
  Properties.UserType ? this.UserType = Properties.UserType : this.UserType = this.__proto__.UserType;
  Properties.AccountTypeID ? this.AccountTypeID = Properties.AccountTypeID : this.AccountTypeID = this.__proto__.AccountTypeID;
  Properties.CompanyID ? this.CompanyID = Properties.CompanyID : this.CompanyID = this.__proto__.CompanyID;
  Properties.Department ? this.Department = Properties.Department : this.Department = this.__proto__.Department;
  Properties.CreationDateTime ? this.CreationDateTime = Properties.CreationDateTime : this.CreationDateTime = this.__proto__.CreationDateTime;
  Properties.CreatorID ? this.CreatorID = Properties.CreatorID : this.CreatorID = this.__proto__.CreatorID;
  Properties.Active ? this.Active = Properties.Active : this.Active = this.__proto__.Active;
  Properties.Deleted ? this.Deleted = Properties.Deleted : this.Deleted = this.__proto__.Deleted;
  Properties.PrincipalID ? this.PrincipalID = Properties.PrincipalID : this.PrincipalID = this.__proto__.PrincipalID;
  Properties.ServiceProviderID ? this.ServiceProviderID = Properties.ServiceProviderID : this.ServiceProviderID = this.__proto__.ServiceProviderID;
  Properties.Email ? this.Email = Properties.Email : this.Email = this.__proto__.Email;
  Properties.EmailConfirmed ? this.EmailConfirmed = Properties.EmailConfirmed : this.EmailConfirmed = this.__proto__.EmailConfirmed;
  Properties.PasswordHash ? this.PasswordHash = Properties.PasswordHash : this.PasswordHash = this.__proto__.PasswordHash;
  Properties.SecurityStamp ? this.SecurityStamp = Properties.SecurityStamp : this.SecurityStamp = this.__proto__.SecurityStamp;
  Properties.TwoFactorEnabled ? this.TwoFactorEnabled = Properties.TwoFactorEnabled : this.TwoFactorEnabled = this.__proto__.TwoFactorEnabled;
  Properties.PhoneNumber ? this.PhoneNumber = Properties.PhoneNumber : this.PhoneNumber = this.__proto__.PhoneNumber;
  Properties.PhoneNumberConfirmed ? this.PhoneNumberConfirmed = Properties.PhoneNumberConfirmed : this.PhoneNumberConfirmed = this.__proto__.PhoneNumberConfirmed;
  Properties.LockoutEndDateUtc ? this.LockoutEndDateUtc = Properties.LockoutEndDateUtc : this.LockoutEndDateUtc = this.__proto__.LockoutEndDateUtc;
  Properties.LockoutEnabled ? this.LockoutEnabled = Properties.LockoutEnabled : this.LockoutEnabled = this.__proto__.LockoutEnabled;
  Properties.AccessFailedCount ? this.AccessFailedCount = Properties.AccessFailedCount : this.AccessFailedCount = this.__proto__.AccessFailedCount;
  Properties.UserName ? this.UserName = Properties.UserName : this.UserName = this.__proto__.UserName;
  Properties.UserAccountPermissions ? this.UserAccountPermissions = Properties.UserAccountPermissions : this.UserAccountPermissions = this.__proto__.UserAccountPermissions;
  Properties.Image ? this.Image = Properties.Image : this.Image = this.__proto__.Image;
  Properties.title ? this.title = Properties.title : this.title = this.__proto__.title;
  // Properties.IndustrySectors                    ? this.IndustrySectors        = Properties.IndustrySectors            : this.IndustrySectors        =  this.__proto__.IndustrySectors
  // Properties.IndustryBranches                   ? this.IndustryBranches       = Properties.IndustryBranches           : this.IndustryBranches       =  this.__proto__.IndustryBranches
  Properties.SelectedSectors ? this.SelectedSectors = Properties.SelectedSectors : this.SelectedSectors = this.__proto__.SelectedSectors;
  Properties.SelectedLanguages ? this.SelectedLanguages = Properties.SelectedLanguages : this.SelectedLanguages = this.__proto__.SelectedLanguages;
  Properties.UserFunction ? this.UserFunction = Properties.UserFunction : this.UserFunction = this.__proto__.UserFunction;
  Properties.DocumentTypeIds ? this.DocumentTypeIds = Properties.DocumentTypeIds : this.DocumentTypeIds = this.__proto__.DocumentTypeIds;
  Properties.Individual ? this.Individual = Properties.Individual : this.Individual = this.__proto__.Individual;
};

User.prototype = {
  UserId: null,
  FormOfAdress: null,
  FirstName: '',
  LastName: '',
  UserType: null,
  AccountTypeID: null,
  CompanyID: null,
  Department: '',
  CreationDateTime: null,
  CreatorID: '',
  Active: null,
  Deleted: null,
  PrincipalID: null,
  ServiceProviderID: null,
  Email: '',
  EmailConfirmed: null,
  PasswordHash: '',
  SecurityStamp: '',
  TwoFactorEnabled: null,
  PhoneNumber: '',
  PhoneNumberConfirmed: null,
  LockoutEndDateUtc: null,
  LockoutEnabled: null,
  AccessFailedCount: null,
  UserName: '',
  Image: '',
  title: '',
  SelectedSectors: '',
  SelectedLanguages: {},
  UserFunction: '',
  DocumentTypeIds: '',
  Individual: false,
};

export default User;
